import '../styles/main.scss'
import { Provider } from 'react-redux';
import { RootState, useStore } from '../src/app/store';
import { ReactNode } from "react";

import { AppPropsLayout } from 'src/utils/types/getLayout';
import { ThemeTT } from '@toctoc/design-system';

export default function MyApp({ Component, pageProps }: AppPropsLayout<{ initialReduxState:RootState}>) {
	// Use the layout defined at the page level, if available
	const getLayout = Component.getLayout || ((page: ReactNode) => page);
	const store = useStore(pageProps.initialReduxState)
	return <Provider store={store}>
		<ThemeTT>{getLayout(<Component {...pageProps} />, pageProps)}</ThemeTT>
	</Provider>
}
